package com.anjuros.website.templates.template2.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.templates.selection.components.contactform.ContactForm
import com.anjuros.website.templates.selection.components.contactform.ContactFormDetailsType
import com.anjuros.website.templates.selection.components.contactform.ContactFormInfo
import com.anjuros.website.templates.selection.components.contactform.MESSAGE_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NAME_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.PHONE_NUMBER_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.SuccessContactMessage
import com.anjuros.website.templates.selection.components.contactform.requiredValidator
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template2.components.Template2SectionTitle
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2ContactBoxStyle
import com.anjuros.website.templates.template2.styles.Template2ContactCardWidthStyle
import com.anjuros.website.templates.template2.styles.Template2ContactTextStyle
import com.anjuros.website.templates.template2.util.ResKey
import com.anjuros.website.templates.template2.util.Template2CompanyDetails
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2ContactSection(){
    Box(
        modifier = Modifier
            .id(Template2Section.Contact.id)
            .backgroundColor(Template2Theme.Background.rgb)
            .fillMaxSize()
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        Column(modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally) {
            Template2ContactContent()

        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun Template2ContactContent() {

var breakpoint = rememberBreakpoint()

    Template2SectionTitle(
        title = ResKey.TEMPLATE2_CONTACT_TITLE,
        text = ResKey.TEMPLATE2_CONTACT_TEXT
    )

        Spacer()

        Box(
            modifier = Template2ContactBoxStyle.toModifier()
                .backgroundColor(Colors.White)
                .borderRadius(28.px)
                .boxShadow(
                    offsetY = 18.px,
                    blurRadius = 40.px,
                    color = rgba(0, 0, 0, .4)
                )
                .padding(22.px)
        ) {

            Row(
                modifier = Modifier
                    .align(Alignment.Center)

                    .fillMaxWidth()
                    .flexDirection(
                        if (breakpoint >= Breakpoint.LG)
                            FlexDirection.Row
                        else
                            FlexDirection.Column
                    ),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {

                Box(modifier = Modifier
                    .fillMaxWidth( if (breakpoint >= Breakpoint.LG) 40.percent else 100.percent)
                    .alignContent(AlignContent.Center)) {
                    Template2BusinessCard(

                    )
                }
                Box(
                    modifier = Modifier
                        .fillMaxWidth(if (breakpoint >= Breakpoint.LG) 60.percent else 100.percent)
                        .alignContent(AlignContent.Center)
                ) {

                    // Your existing form composable
                    Template2ContactBox(
                        modifier = Modifier.fillMaxWidth().alignContent(AlignContent.Center),
                        showBorder = false
                    )

                }

            }

        }

}

@Composable
private fun Template2BusinessCard() {

    Column(
        modifier = Template2ContactCardWidthStyle.toModifier()
            .backgroundImage(
                linearGradient(

                    Theme.Primary.rgb,
                    rgb(16, 30, 55),
                    LinearGradient.Direction.ToBottomRight
                )
            )
            .borderRadius(22.px)
            .padding(34.px),
        verticalArrangement = Arrangement.SpaceBetween
    ) {

        Column {

            AnjurosLogo(
                modifier = Modifier
                    .height(52.px)
                    .margin(bottom = 22.px),
                src = "template2_logo2.png",
                alt = "logo"
            )

            H3(
                attrs = Modifier
                    .fontSize(30.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Colors.White)
                    .margin(bottom = 6.px)
                    .toAttrs()
            ) {
                AnjurosText(Template2CompanyDetails.CLIENTS_COMPANY_INFO)
            }

            P(
                attrs = Modifier
                    .color(rgba(255,255,255,.75))
                    .margin(bottom = 30.px)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE2_CONTACT_CARD_SUBTITLE))
            }

            Template2ContactInfo(
                "template2_contact1.svg",
                Template2CompanyDetails.CLIENTS_PHONE_INFO
            )

            Template2ContactInfo(
                "template2_contact2.svg",
                Template2CompanyDetails.CLIENTS_EMAIL_INFO
            )

            Template2ContactInfo(
                "template2_contact3.svg",
                Template2CompanyDetails.CLIENTS_COMPANY_AREA
            )

        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .margin(top = 30.px)
                .padding(18.px)
                .backgroundColor(rgba(255,255,255,.08))
                .borderRadius(16.px)
                .border(
                    1.px,
                    LineStyle.Solid,
                    rgba(255,255,255,.12)
                )
        ) {

            P(
                attrs = Modifier
                    .fontSize(15.px)
                    .color(Colors.White)
                    .margin(0.px)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE2_CONTACT_CARD_FOOTER))
            }

        }

    }

}

@Composable
private fun Template2ContactInfo(
    icon: String,
    text: Template2CompanyDetails
) {

    Row(
        modifier = Modifier
            .margin(bottom = 18.px)
            .gap(16.px),
        verticalAlignment = Alignment.CenterVertically
    ) {

        Box(
            modifier = Modifier
                .size(44.px)
                .flexShrink(0)
                .backgroundColor(rgba(255,255,255,.08))
                .borderRadius(50.percent)
                .display(DisplayStyle.Flex)
                .justifyContent(JustifyContent.Center)
                .alignItems(AlignItems.Center)
        ) {

            Image(
                modifier = Modifier.size(25.px),
                src = icon,
                alt = ""
            )

        }

        P(
            attrs = Template2ContactTextStyle.toModifier()
                .fontSize(16.px)
                .color(Colors.White)
                .margin(0.px)
                .toAttrs()
        ) {
            AnjurosText(text)
        }

    }

}

@Composable
fun Template2ContactBox(
    modifier: Modifier,
    showBorder: Boolean
) {
    var success by remember { mutableStateOf(false) }

    Box(
        modifier = modifier
            .alignContent(AlignContent.Center) .thenIf(showBorder,Modifier.margin(topBottom =50.px)
                .padding(30.px)
                .position(Position.Relative)
                .border(
                    width = 1.px,
                    color = Theme.DarkGrey.rgb,
                    style = LineStyle.Solid
                ).boxShadow(
                    2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                )
                .borderRadius(5.px))
    ) {

        Box(modifier=Modifier.alignContent(AlignContent.Center)
            .align(Alignment.Center)
           ) {

            ContactForm(
                isDemo = true,
                buttonColor = Template2Theme.Primary.getColor(),
                contactItemsList = listOf(
                    NAME_CONTACT_FORM.copy(index = 0),
                    PHONE_NUMBER_CONTACT_FORM.copy(index = 1),
                    MESSAGE_CONTACT_FORM.copy(index = 2, height = 100.px),
                    ContactFormInfo(
                        index = 3,
                        type = ContactFormDetailsType.RADIO_BUTTON,
                        placeholderText = com.anjuros.website.components.language.ResKey.CONTACT_FORM_URGENCY_LABEL,
                        labelText = com.anjuros.website.components.language.ResKey.CONTACT_FORM_URGENCY_LABEL,
                        nameText = "Urgency",
                        required = true,
                        optionList = listOf(
                            ResKey.TEMPLATE2_CONTACT_DROPDOWN1,
                            ResKey.TEMPLATE2_CONTACT_DROPDOWN2,
                            ResKey.TEMPLATE2_CONTACT_DROPDOWN3,
                        ),
                        validations = listOf(requiredValidator)
                    )
                )
            ) {
                success = true
            }

        }
        SuccessContactMessage(
            modifier = Modifier.align(Alignment.Center),
            isDemo = true,
            showSuccess = success,
            onClose = { success = false }
        )
    }
}
